<template>
  <v-container class="text-center fill-height">
    <v-row class="fill-height">
      <v-col>
        <h1 class="display-2 mb-4">404 - Página Não Encontrada</h1>
        <p class="subtitle-1 mb-4">
          A página que você está tentando acessar não existe. Pode ter sido removida ou o endereço está incorreto.
        </p>
        <v-btn color="primary" @click="voltarParaMenu">
          Voltar ao Menu Principal
        </v-btn>
        <v-btn color="secondary" @click="voltarPaginaAnterior">
          Voltar à Página Anterior
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'PageNotFound',
  setup() {
    const router = useRouter();

    // Função para redirecionar para o Menu principal
    const voltarParaMenu = () => {
      router.push({ name: 'Menu' });
    };

    // Função para voltar à página anterior
    const voltarPaginaAnterior = () => {
      router.back();
    };

    return {
      voltarParaMenu,
      voltarPaginaAnterior,
    };
  },
};
</script>

<style scoped>
h1 {
  color: #1976d2; /* Azul */
}

p {
  color: #757575; /* Cinza */
}
</style>
